import React from 'react';
import { Data } from '../../types/data-providers';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { useData, dataFromDataset } from './DataProviderCache';
import * as SiteManager from '../domain/site-manager';
import { DeviceListData } from '../../types/device';

type ContextState = Data<DeviceListData[]>;

const Context = React.createContext<ContextState | null>(null);

function useSiteDevicesData(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useDevicesData must be used within a SiteDevicesDataProvider');
    }
    return contextState;
}

const SiteDevicesDataProvider: React.FC<{ siteId: string; recursive: boolean; includeflag: boolean }> = (props) => {
    const authHelper = useAuthHelper();

    const { dataset } = useData({
        cacheKey: 'device-list',
        id: props.siteId,
        dataFn: React.useCallback(
            () =>
                SiteManager.getDevices(authHelper, {
                    siteId: props.siteId,
                    recursive: props.recursive,
                    status: props.includeflag,
                }),
            [authHelper, props.siteId, props.recursive, props.includeflag]
        ),
    });
    const siteDevicesData = dataFromDataset(dataset);

    return <Context.Provider value={siteDevicesData}>{props.children}</Context.Provider>;
};

const TestSiteDevicesDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { SiteDevicesDataProvider, TestSiteDevicesDataProvider, useSiteDevicesData };
